module.exports = __webpack_public_path__ + "static/banner-midnight-green-4dccaeed2c1629128d68c4e50546afd1.svg";